/**
 * @author        yewon@zumper.com (Yewon Lee)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   normalizeLng
 */

// recenter a lng to be in range: [-180, 180)
export function normalizeLng(lng: number): number
export function normalizeLng(lng?: null | undefined): null | undefined
export function normalizeLng(lng?: number | null | undefined): number | null | undefined
export function normalizeLng(lng?: number | null) {
  if (lng && lng >= 180) {
    return lng - 360
  } else if (lng && lng < -180) {
    return lng + 360
  }
  return lng
}
